import { render, staticRenderFns } from "./StockViewPurchaseOrder.vue?vue&type=template&id=f0721ad2&scoped=true"
import script from "./StockViewPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./StockViewPurchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./StockViewPurchaseOrder.vue?vue&type=style&index=0&id=f0721ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0721ad2",
  null
  
)

export default component.exports